import angular from 'angular';
import config from './get-started.config';
import controller from './get-started.controller';
import { GetStartedInfoModule } from './info';
import { GetStartedAddressModule } from './address';

export default angular
  .module('app.get-started', [
    GetStartedInfoModule.name,
    GetStartedAddressModule.name,
  ])
  .config(config)
  .controller('GetStartedController', controller);
